<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.noInMainAndChild"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(conditions)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <div>{{ $t('yixuanjihuadanhao') }}: {{ selectedRows.map(row => row.no).join('、') }}</div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #zhuangtai="scope">
        <el-tag :type="scope.row.status === 2 ? 'success' : scope.row.status === 3 ? 'danger' : 'warning'" size="mini">
          {{ $t(store.state.dictJsonAll['PRODUCTION_PLAN_STATUS'][scope.row.status]) }}
        </el-tag>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_order_management_production_plan_batch_close',
  data() {
    return {
      selectedRows: [],
      conditions: {
        status: 1
      },
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          selectable: (row, index) => {
            return true;
          },
          width: '50',
          fixed: true
        },
        {
          label: 'jihuadanhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'quantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'yipaichanshuliang',
          prop: 'schedulingQuantity',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'zhuangtai',
          type: 'slot',
          prop: 'status'
        },
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 选择行数据回调
    selectionChange(e) {
      console.log('选择行数据', e);
      this.selectedRows = e || [];
    }
  }
};
</script>
